import { render, staticRenderFns } from "./tabExternalProject.vue?vue&type=template&id=9205c7c0&scoped=true&"
import script from "./tabExternalProject.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9205c7c0",
  null
  
)

export default component.exports